import React from 'react'
import classNames from "classnames";
import withStyles, { ClassNameMap } from "@material-ui/core/styles/withStyles";
import { ContextMenuTrigger } from "react-contextmenu";
import { Draggable, DraggableProvided, DraggableStateSnapshot } from '../react-beautiful-dnd';
import { ColumnType } from "./Column";
import { LookaheadTag, LookaheadTagStatus } from "../../models/LookaheadTag";
import { connect } from 'react-redux';
import { compose } from 'redux';
import { styles } from '../../containers/dockPadStyle'
import { ThunkDispatch } from 'redux-thunk';
import { phasePlanActions } from '../../actions/phaseplan.actions';
import { lookaheadActions } from '../../actions/lookahead.actions';
import { isTagSelected, isTagCommitted, isLockedDown, getRowGroupTag, getGroupBounds } from '../../selectors/lookahead.selector';
import { createSelectable } from 'react-selectable-fast'
import fontColorContrast from 'font-color-contrast';
import { SelectedTag } from '../../models/ TagType';
import Avatar from '@material-ui/core/Avatar';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import moment, { Moment } from 'moment'

import '../../containers/App.css'
import { alertActions } from '../../actions/alert.actions';
import { getSize, getZoomAmount } from './Zoom.util';
import { Typography } from '@material-ui/core';
import chroma from 'chroma-js'
import { RowGroup } from '../../models/Lookahead';

const _ = require('lodash')


require('../../assets/react-contextmenu.css');

export interface CardProps {
    zoomStep?: number | null;
    classes: ClassNameMap;
    tag: RowGroup;
    index: number
    column: number,
    isDisabled: boolean,
    errorAlert: (message: string) => void
    rowGroup: RowGroup,
    groupBounds: Record<number, Bound>
}


class _GroupTag extends React.Component<CardProps> {
        
    onTagDoubleClick = (event: any) => {
        event.stopPropagation()

    }

    onTagClick = (event: any) => {
        event.stopPropagation()

    }

    shouldComponentUpdate(nextProps: CardProps) {
            
        if(!_.isEqual(nextProps.tag, this.props.tag)) {
            return true
        }

        if(nextProps.isDisabled !== this.props.isDisabled) {
            return true
        }


        if(nextProps.zoomStep !== this.props.zoomStep) {
            return true
        }

        return false
    }

    renderContent = () => {

      const {rowGroup, tag, classes} = this.props

        const zoomAmount = getZoomAmount(this.props.zoomStep)

        const { fontSize, averagePadding, iconSize } = getSize(zoomAmount)



        return (
                <div style={{ paddingLeft: averagePadding }} className={classes.TagCardContent}>
                    <div className={classes.TagNameContainer}>
                        <Typography className={classes.TagNameText} style={{fontSize: fontSize}}  variant="body2">{tag.name}</Typography>
                    </div>
                    <div className={classes.TagCrewContent}>
                        <AccountCircleIcon style={{height: iconSize, width: iconSize, color: rowGroup.color }} /><Typography style={{fontSize: fontSize}}  variant="body2">{tag.crewSize}</Typography>
                    </div>
                </div>
        )
        
    }
    renderTradeColor = () => {
        const { classes, rowGroup } = this.props

        const zoomAount = getZoomAmount(this.props.zoomStep) as number
        const { width, defaultWidth } = getSize(zoomAount)

        const newWidth = (width * 16) / defaultWidth


        return (
            <div style={{width: newWidth, minWidth: newWidth, backgroundColor: rowGroup.color}} className={classes.TradeIndicator}>

            </div>
        )
    }



    render() {
        const { tag, index, column, groupBounds } = this.props
        if(!tag) {
            return (
                <React.Fragment>
                    
                </React.Fragment>
            )
        }
        const groupBound = groupBounds[index]
        const tagId = !!tag.uid ? tag.uid : ""
        const zoomAmount = getZoomAmount(this.props.zoomStep)

        const { width, height, margin, paddingTop, paddingRight, paddingLeft, defaultWidth, fontSize } = getSize(zoomAmount)
        const columnMoment = moment(column).format('l')

        const isStart = columnMoment === groupBound.start
        const isEnd = columnMoment === groupBound.end

        const attributes = {
            'column': column !== null && column !== undefined ? column : -1,
            'row': index !== null && index !== undefined ? index : -1,
            'tagId': tagId,
        }

        const fontColor = fontColorContrast(!!tag.color ? tag.color : '#4286dd')

        const expand = (isStart || isEnd) ? 2.5 : 2.5
        return (
            <div
                style={{ outline: 0 }}

            >
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: width + expand * margin, 
                    height: height + 2 * margin,
                    backgroundColor: !!tag.color ? tag.color : '#4286dd',
                    borderBottomRightRadius: isEnd ? 4 : 0,
                    borderTopRightRadius: isEnd ? 4 : 0,
                    borderTopLeftRadius: isStart ? 4 : 0,
                    borderBottomLeftRadius: isStart ? 4 : 0

                }}> 
                    <Typography  style={{fontSize: fontSize, color: fontColor}} variant="body2">{tag.name}</Typography>
                </div>
            </div>
        )
    }
}


const mapStateToProps = (state:any, ownProps?: any) => ({
    tag: getRowGroupTag(state, ownProps),
});

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => {

    return {
        errorAlert: (message: string) => dispatch(alertActions.error(message)),
    }
};
export const GroupTag =  compose(
  withStyles(styles, { withTheme: true }),
  connect(mapStateToProps, mapDispatchToProps),
)(_GroupTag);



// WEBPACK FOOTER //
// ./src/components/PhasePlan/GroupTag.tsx